<style>
  .dropdown-toggle::before,
  .dropdown-toggle::after {
    border: none;
    content: none;
  }

  .dropdown-toggle:hover {
    background-color: #48a6a6;
    color: white;
  }

  .dropdown-toggle {
    border-radius: 50%;
  }

  .dropdown-item {
    cursor: pointer;
  }
</style>
<template>
  <tr>
    <!-- avatar -->
    <!-- <td>
      <img v-if="!!user.avatar" :src="avatar" height="50px" :alt="user.username" />
      <img v-else :src="avatar" height="50px" alt="user_avatar" />
    </td> -->
    <td>
      <input type="checkbox" :data-id="organization.organization_id" class="user_row" name="" />
      <a @click="quickView" >
              <i :data-id="organization.organization_id" class="fa fa-eye color-default org_quick_view">
              </i>
            </a>
    </td>

    <!-- company name -->
    <td align="left">{{ organization.legal_name }}</td>

    <!-- username -->
    <td align="left">{{ organization.user_name }}</td>

    <!-- email -->
    <td align="left">{{ organization.email }}</td>

    <!-- phone -->
    <td>{{ organization.phone }}</td>
    <td>{{ organization.country }}</td>
    <td>{{ organization.state }}</td>
    <td>{{ organization.city }}</td>


    <!-- created -->
    <td>{{ organization.created_at_date | formatDate}}</td>

    <!-- status -->
    <!-- <td>{{ organization.status }}</td> -->
    <div v-if="organization.organization_id != edit_id && this.product != 1">
          <span v-if="show && organization.status === '1'" style="color: #66b34d; font-weight: 700; font-size: 12px; text-align:center;">
          <span class="bullet">• </span>Active</span>
    </div>
    <td v-if="flag && this.product == 1" class="pr-0">
        <div class="row status_col">
              <div v-if="organization.organization_id != edit_id" style="display:flex">
                <span v-if="show && organization.status == 1" style="color: #66b34d; font-weight: 700; font-size: 12px; text-align:center;">
                  <span class="bullet">• </span>Active </span>
                <span v-if="show && organization.status == 2" style="color: #a682b2; font-weight: 700; font-size: 12px; text-align:center;">
                  <span class="bullet">• </span>Trial</span>
                <span v-if="show && organization.status == 3" style="color: #e95a42; font-weight: 700; font-size: 12px; text-align:center;">
                  <span class="bullet">• </span>Inactive</span>
                <span v-if="show && organization.status == 4" style="color: rgb(241, 154, 22);; font-weight: 700; font-size: 12px; text-align:center;">
                  <span class="bullet">• </span>Warning</span>
                <span v-if="show && organization.status == ''" style="color: #4842e9; font-weight: 700; font-size: 12px; text-align:center;">
                  -------</span>
                
                <!-- <a v-if="organization.organization_id == organization_status_id && show" style="padding-top:10px !important" class="fa fa-edit pl-3" @click="showDropDown(organization.organization_id)">
                </a> -->
              </div>
              <!-- <div v-if="showstatus && organization.organization_id == edit_id">
                <select class="form-control" style="padding: 0 !important;" :data-status="organization.status" :data-id="organization.organization_id"  v-on:change="changeUserStatus"> -->
                  <!-- <span  style="color: #66b34d"  v-if="organization.status === '1'">
                    Active
                  </span>
                  <span style="color: #a682b2" v-if="organization.status === '2'">
                    Trial
                  </span>
                  <span style="color: #e95a42"  v-if="organization.status === '3'">
                    Inactive
                  </span>
                  <span style="color: rgb(241, 154, 22);" v-if="organization.status === '4'">
                    Warning
                  </span> -->
                <!-- </select>
              </div> -->
              <!-- <div class="px-1">
                <button v-if="organization.organization_id == edit_id" class="fa fa-check btn btn-success btn-sm" @click="showDropDown(organization.organization_id)"></button>
              </div>
              <div class="">
                <button v-if="organization.organization_id == edit_id" class="fa fa-times btn btn-outline-secondary btn-sm" @click="hideDropDown()"></button>
              </div> -->
            </div>
    </td>

    <!-- actions -->
    <td>
      <!--<div class="btn-group btn-group-sm">
        <router-link class="btn btn-success" :to="'/users/' + organization.user_id + '/posts'">View</router-link>

        <button
          @click="createUserNote"
          type="button"
          class="btn btn-primary"
          :data-id="organization.user_id"
        >Note</button>

      </div> -->
      <div class="btn-group">
        <a class="btn dropdown-toggle" data-toggle="dropdown" href="#">
          <span class="fas fa-ellipsis-v"></span>
        </a>
        <ul class="dropdown-menu">
          <router-link
              v-if="$can('all_organization_view') && organization.user_id"
              class="dropdown-item"
              :to="`/organizations/detail/${organization.user_name}/${organization.user_id}/${organization.organization_id}`"
          >
            View
          </router-link>
          <!-- <router-link class="dropdown-item" :to="
              '/organizations/document/' +
              organization.user_name +
              '/' +
              organization.organization_id
            ">Upload</router-link> -->

            <a class="dropdown-item"  v-if="$can('all_organization_view_contract_detail')" @click="openOrganizationContract" :data-id="organization.organization_id"  >View Contract Details</a>
            <a class="dropdown-item" v-if="$can('all_organization_demo_video')" @click="uploadDemoVideoLink" :data-id="organization.organization_id" >Demo Video</a>
            <a class="dropdown-item" v-if="$can('all_organization_set_price')" @click="uploadPlanPrice" :data-id="organization.organization_id" >Set Price</a>
            <a class="dropdown-item" v-if="$can('all_organization_document')" @click="uploadDocument" :data-id="organization.organization_id" :data-name="organization.user_name" >Document</a>
            <a class="dropdown-item" v-if="organization.status == 2" @click="trialDateForm" :data-id="organization.organization_id" >Extend Trial</a>
            <a class="dropdown-item" v-if="$can('all_organization_update_status')" @click="updateStatus" :data-status="organization.status" :data-id="organization.organization_id" >Update status</a>
          <a v-if="$can('all_organization_note') && organization.user_id" class="dropdown-item" @click="createUserNote"
            :data-id="organization.user_id">Note</a>
          <a v-if="$can('all_organization_email') && organization.user_id" class="dropdown-item" @click="sendEmail"
            :data-id="organization.user_id">Email</a>
          <a class="dropdown-item"  v-if="$can('all_organization_settings')" @click="uploadSetting" :data-id="organization.organization_id" :data-name="organization.user_name">Settings</a>  
          <a v-if="$can('all_organization_adds_on') && this.product == 1" class="dropdown-item" @click="uploadAddOn" :data-id="organization.organization_id" :data-name="organization.user_name">Add-ons</a>
          <!-- <router-link class="dropdown-item" :to="
              '/organizations/settings/' +
              organization.user_name +
              '/' +
              organization.organization_id
            ">Settings</router-link> -->
          <a :disabled="password_reset" class="dropdown-item" @click="testMethod" 
            :data-id="organization.organization_id" >{{
            password_reset && password_reset == 1
            ? "Request Sent"
            : "Reset Password"
            }}</a>
        </ul>
      </div>
    </td>
  </tr>
</template>

<script>
  import moment from "moment";
  import $ from "jquery";
  Vue.filter("formatDate", function (value) {
    if (value != "0000-00-00 00:00:00" && value != null) {
      return moment(String(value)).format("MMM DD, Y LT");
    }
  });
  import noteForm from "./note_form";
  import email from "./email";
  import notesHistory from "./notes_history";
  import demoLinkForm from "./demo_link_form.vue";
  import pricePlanForm from "./price_plan_form.vue";
  import organizationSettings from "./organization_settings.vue";
  import AddOnSettings from "./add_on_settings.vue";
  import orgquickView from "./org_quick_view.vue";
  import updateStatus from "./form.vue";
  import trialEndDate from "./trial_end_date.vue";
  import trialDateForm from "./trial_date_form.vue";
  import documentUploadForm from "./upload_document_form.vue";
  import axios from "axios";
  

  export default {
    props: ["organization", "check_all","page","tab","search"],

    data: function () {
      return {
        // status: '',
        product: 1,
        password_reset: 0,
        // organization_status_id:"",
        show: true,
        edit_id: "",
        organization_id: "",
        filter_status: "",
        showstatus: false,
        flag:true,
        // upHere: false,
        status: 0,
        // loader: false
      };
    },
    computed: {
      loader:function(){
        return this.isLoader;
      },
      org_status: function () {
        return this.$store.getters['persist/organization_status'];
      },
    },
    created: function () {
      this.product = localStorage.getItem('product');
    },


    watch: {
      loader: function (val) {
          return val;
      }
    },

    mounted: function () {
      this.edit_id = false;
    },
    methods: {
      
      
      // UpHere(id) {
      //   this.organization_status_id = id;
      // },
      // DownHere() {
      //   this.organization_status_id = false;
      // },
      //  showDropDown(id) {
      //   if (!this.showstatus) {
      //     this.edit_id = id;
      //     this.showstatus = true;
      //   }else {
      //     this.edit_id = false;
      //     this.showstatus = false;
      //     if (this.organization_id == id) {

      //       if(this.status == 2){
      //     this.trialenddate(this.status, this.organization_id);
      //     }
      //     else{
      //         // let loader = this.$loading.show({
      //         // loader: 'dots',
      //       // });
      //       this.isLoader = true;
      //       this.$store
      //       .dispatch("users/changeStatus", [this.status, this.organization_id,''])
      //       .then(() => {
      //         // send successful message
      //         this.$toast.success('Status Successfully Changed');
      //         setTimeout(() => {
      //           // loader.hide();
      //           this.isLoader = false;
      //             this.status = 0;
      //             this.organization_id = '';
      //              this.showstatus = false;
      //             this.$store.dispatch('users/getAllOraganizations', [this.page, '',this.filter_status]);
      //     }, 1000)
      //         // this.$router.push("/organizations");
      //       });
            

            
      //     }

      //     }
      //   }
      // },
      // hideDropDown() {
      //   this.edit_id = false;
      //   this.showstatus = false;
          
      // },
      changeUserStatus(event) {
       
        this.status = event.target.value;
       this.organization_id = event.target.dataset.id;
        this.filter_status = localStorage.getItem('filter_status');
        
      },

      trialenddate(status_selected,org_ids) {
        
        let pageNumber = this.page;
        this.$store.dispatch("modal/trialenddate", {
          action: "create",
          title: "Set Trial End Date",
          formData: {
            status_selected: status_selected,
            org_ids: org_ids,
          },
          component: trialEndDate,
        });
        
      },
      openOrganizationContract (event) {
        let org_id = window.btoa(event.target.dataset.id);
        let contract_url = process.env.VUE_APP_LINENTECH_V3 + "/organization/contract/view?organization_id=" + org_id;
        window.open(contract_url, "_blank");
      },

      uploadDemoVideoLink(event) {
        let id = event.target.dataset.id;
        
        let pageNumber = this.page;
        this.$store.dispatch("modal/uploadDemoVideoLink", {
          action: "create",
          title: "Demo Video Links",
          formData: {
            org_id: id,
          },
          component: demoLinkForm,
        });
      },
      uploadPlanPrice(event){
        let id = event.target.dataset.id;
        
        let pageNumber = this.page;
        this.$store.dispatch("modal/uploadPlanPrice", {
          action: "create",
          title: "Plan Price",
          formData: {
            org_id: id,
          },
          component: pricePlanForm,
        });
      },
      uploadSetting(event) {
        let id = event.target.dataset.id;
        let name = event.target.dataset.name;
        let pageNumber = this.page;
        this.$store.dispatch("modal/organizationSettingsLink", {
          action: "create",
          title: "Organization Settings",
          formData: {
            org_id: id,
            org_name: name,
          },
          component: organizationSettings,
        });
      },
      uploadAddOn(event) {
        let id = event.target.dataset.id;
        let name = event.target.dataset.name;
        let pageNumber = this.page;
        this.$store.dispatch("modal/AddOnSettingsLink", {
          action: "create",
          title: "Add-ons",
          formData: {
            org_id: id,
            org_name: name,
          },
          component: AddOnSettings,
        });
      },
      
      trialDateForm(event) {
        let id = event.target.dataset.id;
        
        let pageNumber = this.page;
        this.$store.dispatch("modal/trialDateForm", {
          action: "create",
          title: "Current Trial Date",
          formData: {
            org_id: id,
            // trial_in_days: false,
          },
          component: trialDateForm,
        });
      },
      

      uploadDocument(event) {
        let id = event.target.dataset.id;
        let name = event.target.dataset.name;
        
        
        let pageNumber = this.page;
        this.$store.dispatch("modal/uploadDocument", {
          action: "create",
          title: "Upload Document",
          formData: {
            org_id: id,
            u_name:name
          },
          component: documentUploadForm,
        });
      },

      quickView(event) {
        let id = event.target.dataset.id;
        this.$store.dispatch("modal/orgquickView", {
          action: "create",
          title: "",
          formData: {
            org_id:id,
            product: this.product,
          },
          component: orgquickView,
        });
      },

      

      createUserNote(event) {
        let user = event.target.dataset.id;
        this.$store.dispatch("modal/update", {
          action: "create",
          title: "User Note",
          formData: user,
          component: noteForm,
        });
      },

      sendEmail(event) {
        let user = event.target.dataset.id;
        this.$store.dispatch("modal/update", {
          action: "create",
          title: "Email",
          formData: user,
          component: email,
        });
      },

      showNotesHistory(event) {
        let user = event.target.dataset.id;

        this.$store.dispatch("modal/update", {
          title: "Notes History",
          formData: user,
          component: notesHistory,
        });
      },

      testMethod(event) {
      let org_id = event.currentTarget.getAttribute("data-id");

      this.$store.dispatch("message/update", {
          title: "Reset password request",
          body: "Are you sure to send reset password request to this User?",
          class: "success",
          confirm: true,
        });
        this.$bus.$off("proceed");
        this.$bus.$once("proceed", () => {
          let _self = this;
          if (!org_id) return;
          axios
            .get("/admin/password_reset?org_id=" + org_id)
            .then((res) => {
              _self.password_reset = 1;
            })
            .catch((err) => { });
          this.$store.dispatch("message/close");
        });
      },
      updateStatus(event){
        let org_id = event.target.getAttribute("data-id");
        let org_status = event.target.getAttribute("data-status");
        let status_array= this.org_status;
        let sel_teams=[];
        if(org_status){
                  
          status_array.forEach((key) => {
            if(org_status == key.value){
              sel_teams.push({"value":key.value,"name":key.name});
            }   
          });
        }
        this.$store.dispatch("modal/updateStatus", {
          action: "update",
          title: "Update Organization Status",
          formData: {
            org_id:org_id,
            org_status:sel_teams,
            trial_status:[{name:"",value:''}],
            page:this.page,
            tab:this.tab,
            search: this.search,
          },
          component: updateStatus,
        });
      },

      organizationDetails(userName,userId,organizationId){
        this.$router.push(`/organizations/detail/${userName}/${userId}/${organizationId}`);
      },
      
    },
  };
</script>
<style scoped>

.dropdown {
    position: relative;
    display: inline-block;
  }

  .dropdown-content {
    display: none;
    position: absolute;
    background-color: white;
    width: 140px;
    border-radius: 10px;
    border: 1px solid #b6c7d2;
    right: 100%;
    z-index: -1;
    margin-top: -30px;
  }

  .dropdown-content button {
    display: block;
    width: 100%;
    text-align: left;
    padding: 0px 0 5px 15px;
  }

  .dropdown-content button:hover {
    border-radius: 2px;
    background-color: #edf2f5;
  }

  .dropdown:hover .dropdown-content {
    display: block;
  }

  a.btn:focus {
    background-color: #48a6a6;
    color: white;
  }
  .row.status_col{
    cursor: pointer;
    transform: translateX(40%);
  }

  .dropdown-menu a:hover {
    border-radius: 2px;
    color: white;
    background-color: #48a6a6;
  }
  .table-light th, .table-light td, .table-light thead th, .table-light tbody + tbody {
    border: none;
}
.org_quick_view{
  cursor: pointer; padding-left: 18px;
    transform: translateY(0px); 
    /* position:absolute; */
}
@media (min-width: 720px) and (max-width:1280px){
.row.status_col{
    cursor: pointer;
    transform: translateX(25%);
  }
  .org_quick_view{
  cursor: pointer; padding-left: 8px;
    transform: translateY(0px); 
    /* position:absolute; */
}
}
</style>